import { useEffect, useState } from "react";

import { useAsyncCurrency } from "../../../Components/hooks/useCurrency";
import { useCurrencyFormat } from "../../../Components/hooks/useCurrencyFormat";

export const useAmountInCustomerCurrency = (amount: number, dontConvert?: boolean) => {
  const { asyncConvertCurrency } = useAsyncCurrency();

  const [convertedAmount, setConvertedAmount] = useState(0);

  useEffect(() => {
    if (!dontConvert) {
      asyncConvertCurrency(amount).then((convertedAmount) => {
        setConvertedAmount(convertedAmount);
      });
    } else {
      setConvertedAmount(amount);
    }
  }, [amount, asyncConvertCurrency, dontConvert]);

  return convertedAmount;
};

export const AmountInCustomerCurrency = ({ amount, dontConvert }: { amount: number; dontConvert?: boolean }) => {
  const formatCurrency = useCurrencyFormat();
  const convertedAmount = useAmountInCustomerCurrency(amount, dontConvert);

  return formatCurrency(convertedAmount);
};
